<template>
  <el-date-picker
    class="pickerWidth"
    v-model="dateValues"
    type="daterange"
    :align="getAlign"
    :placeholder="placeholder"
    :disabled="disabled"
    :picker-options="pickerOptions"
    @change="changeValue">
  </el-date-picker>
</template>

<script>
import moment from 'moment'

export default {
  name: 'daterange',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: '选择日期范围'
    },
    dataType: {
      type: String,
      default: 'string'
    },
    value: {
      type: Array,
      default: () => []
    },
    shortcuts: {
      type: Array
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      // pickerOptions: {
      //   shortcuts: this.shortcuts
      // }
      pickerOptions: {
        disabledDate (date) {
          // return date.getTime() > Date.now() - 1
          let nowData = new Date()
          nowData = new Date(nowData.setDate(nowData.getDate() - 1))
          return date > nowData
        }
      }
    }
  },
  computed: {
    getAlign () {
      return this.shortcuts && this.shortcuts.length ? 'align' : ''
    },
    dateValues: {
      get () {
        return this.value.length ? this.value.map(item => moment(item, 'x').toISOString()) : []
      },
      set (value) {
        const setValue = value[0] || value[1] ? value.map(item => (moment(item).format('x'))) : []
        this.$emit('input', setValue)
      }
    }
  },
  methods: {
    changeValue (value) {
      const times = value.split(' - ')
      const result = {
        start: times[0] && times[0] !== '' ? moment(times[0], 'YYYY-MM-DD').startOf('day').format('x') : undefined,
        end: times[0] && times[0] !== '' ? moment(times[1], 'YYYY-MM-DD').endOf('day').format('x') : undefined
      }
      this.$emit('changeValue', result)
    }
  }
}
</script>
<style scoped lang="sass">
  .pickerWidth
    width: 100%
    border-color: #e8e8e8
</style>


// WEBPACK FOOTER //
// SmartDateRange.vue?8f615186